import React, {useState, useEffect} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';
import axios from 'axios';

const ClientTestimonial = () => {
    const [testimonialData, setTestimonialData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await axios.get("/api/alltestimonials"); // Adjust port if needed
                const fetchedData = Array.isArray(res.data) ? res.data : []; // Assuming data is an array
                setTestimonialData(fetchedData);
            } catch (err) {
                console.error("Error fetching data:", err);
                setTestimonialData([]);
            }
        };
        fetchData();
    }, []);
    
    return (
        <section className="client-testimonial relative py-12">
          <div className='container mx-auto relative'>
            <div className='w-3/4 md:w-1/2 mx-auto'>
                <div className="client-testimonial-head flex flex-col text-center items-center justify-center align-middle">
                    <h2 className="relative text-2xl leading-8 font-bold uppercase font-montserrat mb-2">
                    <span className="absolute top-1/2 -left-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                    <span className=' text-slate-500 font-thin'>Client</span> Testimonial
                    <span className="absolute top-1/2 -right-14 -mt-px h-0.5 w-12 bg-orange-400"></span>
                    </h2>
                </div>
                <div className='flex justify-center items-center text-center pt-5 relative'>
                {testimonialData.length > 0 ? (
                <Swiper
                    loop={true}
                    spaceBetween={30}
                    centeredSlides={true}
                    autoplay={{
                    delay: 3500,
                    disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}  
                    navigation={true}
                    modules={[Autoplay, Pagination]}
                    className="mySwiper"
                >
                    {testimonialData.map((data, idx) => (
                    <SwiperSlide key={idx}>
                        <div className="w-full h-auto flex flex-col items-center justify-center gap-6 mb-9">
                            <div className="text-lg text-gray-600 text-center w-4/5 relative px-3">
                                <span className='absolute top-0 left-0 text-5xl'>"</span><span>{data.message}</span><span className='absolute -bottom-7 right-0 text-5xl text-end'>"</span>
                            </div>
                            <div className="flex items-center gap-4">
                                <div className="flex flex-col tracking-wider">
                                    <label className="text-gray-600 font-bold text-base">{data.clientname}</label>
                                    {/* <label class="text-gray-400 font-normal text-sm">Fullstack PHP Developer</label> */}
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                    ))}
                </Swiper>
                ) : (
                    <p className="text-center text-gray-500">No testimonials available</p>
                )}
                </div>
            </div>
          </div>
        </section>
    );
}

export default ClientTestimonial;
